import React from 'react';
import { Link } from 'react-router-dom';
import { useLanguage } from '../context/LanguageContext';
import { Film, Star, Sparkles, FileText, Eye, Camera } from 'lucide-react';

const categoryIcons = {
  newReleases: Film,
  classics: Star,
  cult: Sparkles,
  documentaries: FileText,
  hiddenGems: Eye,
  directors: Camera,
};

const CategoryCard = ({ categoryKey, label }) => {
  const Icon = categoryIcons[categoryKey] || Film;

  return (
    <Link
      to={`/categories/${categoryKey}`}
      className="group relative overflow-hidden border border-[#52ea88]/10 hover:border-[#52ea88]/40 transition-all duration-400 p-8 bg-[#121917]"
    >
      {/* Subtle Background Glow Effect */}
      <div className="absolute inset-0 bg-gradient-to-br from-[#52ea88]/3 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-400" />

      <div className="relative z-10 space-y-4">
        {/* Icon */}
        <div className="w-14 h-14 border border-[#52ea88]/20 flex items-center justify-center group-hover:border-[#52ea88]/50 transition-colors">
          <Icon className="w-6 h-6 text-[#52ea88]" />
        </div>

        {/* Label */}
        <h3 className="text-xl font-semibold text-[#E6FFF6] group-hover:text-[#52ea88] transition-colors">
          {label}
        </h3>

        {/* Decorative Line */}
        <div className="w-8 h-0.5 bg-[#9FBFB4]/20 group-hover:bg-[#52ea88] group-hover:w-12 transition-all duration-400" />
      </div>
    </Link>
  );
};

const Categories = () => {
  const { t } = useLanguage();

  const categories = [
    { key: 'newReleases', label: t('categories.newReleases') },
    { key: 'classics', label: t('categories.classics') },
    { key: 'cult', label: t('categories.cult') },
    { key: 'documentaries', label: t('categories.documentaries') },
    { key: 'hiddenGems', label: t('categories.hiddenGems') },
    { key: 'directors', label: t('categories.directors') },
  ];

  return (
    <section className="bg-[#0B0F0E] py-24 border-t border-[#52ea88]/5">
      <div className="max-w-[1400px] mx-auto px-6 lg:px-[7.6923%]">
        {/* Section Header */}
        <div className="space-y-2 mb-12">
          <h2 className="text-3xl md:text-4xl font-semibold text-[#E6FFF6]">
            {t('sections.categories')}
          </h2>
          <div className="w-20 h-1 bg-[#52ea88]"></div>
        </div>

        {/* Category Grid */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {categories.map((cat) => (
            <CategoryCard key={cat.key} categoryKey={cat.key} label={cat.label} />
          ))}
        </div>
      </div>
    </section>
  );
};

export default Categories;
